import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
// Import Swiper React components
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import InformationOrganize from '../InformationOrganize';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';
SwiperPage2.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
};

SwiperPage2.defaultProps = {
  id: '',
  isActive: false,
};

function SwiperPage2({ id, isActive }) {
  const [animationClass, setAnimationClass] = useState('');
  const [activeSlide, setActiveSlide] = useState(0); // Trạng thái slide hiện tại
  const swiperRef = useRef(null); // Lưu Swiper instance

  // Hàm xử lý khi click vào highlight
  const handleHighlightClick = (index) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index); // Chuyển slide theo index
    }
  };

  const listOrganize = [
    {
      id: 'in3d',
      description:
        'Sử dụng máy in 3D FDM chuyên dụng, chúng tôi mang đến sản phẩm chất lượng cao, hoàn thiện nhanh, với nhựa PLA và PETG thân thiện môi trường.',
    },
    {
      id: 'laser',
      description:
        'Sử dụng máy khắc cắt Laser chuyên dụng, chúng tôi mang đến sản phẩm chất lượng cao, hoàn thiện nhanh, với gỗ MDF và PolyWood thân thiện môi trường.',
    },
    {
      id: 'foam',
      description:
        'Sử dụng các bìa Foam cứng được với khả năng thủ công khéo léo lắp ghép các thành phần lại với nhau tạo nên thành phẩm ngoài sức tưởng tượng ',
    },
  ];

  useEffect(() => {
    if (isActive) {
      setAnimationClass('active'); // Khi active, chạy animation
    } else {
      setAnimationClass(''); // Nếu không active, reset
    }
  }, [isActive]);

  return (
    <div className={`hero-section hero-section-${id} ${animationClass}`}>
      <div class="hero-content">
        {/* <!-- Information Box --> */}
        <div class="information-organize-box">
          <h1 class="title">Organize Boardgame</h1>
          <p class="description">
            <span>Organize Boardgame</span> giúp bạn sắp xếp bộ sưu tập boardgame một cách gọn gàng và khoa học. Với
            thiết kế thông minh và các phụ kiện
            <span className={`highlight ${activeSlide === 0 ? 'active' : ''}`} onClick={() => handleHighlightClick(0)}>
              In 3D
            </span>
            ,
            <span className={`highlight ${activeSlide === 1 ? 'active' : ''}`} onClick={() => handleHighlightClick(1)}>
              Gỗ
            </span>
            ,
            <span className={`highlight ${activeSlide === 2 ? 'active' : ''}`} onClick={() => handleHighlightClick(2)}>
              Foam
            </span>
            chuyên dụng, từng linh kiện sẽ được bảo quản tối ưu, giúp bạn duy trì sự ngăn nắp và tận hưởng trọn vẹn
            những ván chơi mà không lo thất lạc hay lộn xộn.
          </p>
          <div className="cta-button">
            <a
              href="https://www.facebook.com/GamePieceLabs"
              className="cta-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tư vấn làm Organize
            </a>
          </div>
        </div>

        {/* <!-- Album Box --> */}
        <div class="album-box">
          <div class="swiper-container-organize3d">
            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              modules={[Pagination]}
              pagination={{
                el: '.custom-pagination-organizer',
                clickable: true,
                renderBullet: (index, className) => {
                  const labels = ['In 3d', 'Cắt Laser', 'Cắt Foam'];
                  return `<span class="${className}">${labels[index]}</span>`;
                },
              }}
              onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              // Lưu swiper instance
            >
              {/* Nhựa */}
              <SwiperSlide>
                <InformationOrganize infoOrganize={listOrganize[0]} />
              </SwiperSlide>
              {/* Gỗ */}
              <SwiperSlide>
                <InformationOrganize infoOrganize={listOrganize[1]} />
              </SwiperSlide>
              {/* Foam */}
              <SwiperSlide>
                <InformationOrganize infoOrganize={listOrganize[2]} />
              </SwiperSlide>
            </Swiper>
          </div>
          {/* <!-- CustomPaginationOrganizer --> */}
          <div class="custom-pagination-organizer"></div>
        </div>
      </div>
    </div>
  );
}
export default SwiperPage2;
